import styled from "styled-components"

import Icon from "@irati/ui/src/Icon"
import {H6} from "@irati/ui/src/Typography"

export const PopularWrapper = styled.div`
  position: absolute;
  width: 91px;
  height: 70px;
  right: 0;
  top: 0;
  overflow: hidden;
`

export const Popular = styled.div`
  width: 115px;
  height: 39px;
  background: linear-gradient(96deg, #65e7e2 16.05%, #41ff6b 98.9%);
  transform: rotate(37deg);
`

export const StyledIcon = styled(Icon)`
  position: relative;
  left: 2px;
  path:last-child {
    fill: ${({theme}) => theme.colors.greys.white};
  }
`

export const StyledH6 = styled(H6)`
  position: relative;
  left: -3px;
  font-size: 10px;
`
